<template>
  <div id="login">
    <div class="container">
      <router-link to="/" class="login-logo"></router-link>
      <p class="login-line">|</p>
      <p class="">通行证</p>
    </div>
    <div class="login-form">
      <div class="login-tit">艺人之家</div>
      <div class="" style="width: 300px;margin: 0 auto; font-size:16px">
        <div class="float-left login-tab login-tab-active">
          <router-link to='/login'>登录</router-link>
        </div>
        <div class="float-right login-tab">
          <router-link to='/register'>注册</router-link>
        </div>
        <div class="clearfix"></div>
      </div>
      <form class="form-style">
        <div class="input-log1">
          <i></i>
          <input autocomplete="on" v-model="mobile" type="text" required="required" placeholder="请输入您的手机号"/>
        </div>
        <div class="input-log2">
          <i></i>
          <input v-model="password" type="password" required="required" @keyup.13="login()" placeholder="请输入密码"/>
        </div>

        <input class="btn" @click="login()" type="button" value="登  录"/>
        <div class="form-foo">
          <!-- <input class="float-left" type="checkbox" value="" style="width: 20px;height: 20px;cursor: pointer;">
          <span class="float-left" style='font-size: 14px;margin-left: 10px;'>
						记住密码
					</span> -->
          <span class="float-right" style='font-size: 14px;'>
						<router-link to='/forgetpwd'>忘记密码？</router-link>
					</span>
          <div class="clearfix"></div>
        </div>

      </form>
    </div>
    <div class="clearfix"></div>
  </div>

</template>

<script>
  import Axios from 'axios'
  import storage from '../storage/storage.js'

  export default {
    data() {
      return {
				mobile:'',
				password:'',
			}
    },
    methods: {
      login() {

        if (!this.mobile) { //判断用户是否输入，后期加入正则匹配是否输入合法
          this.$message({
            message: '请输入手机号！',
            type: 'error',
            center: true
          });
          return;
        }
        if (!this.password) { //判断用户是否输入，后期加入正则匹配是否输入合法
          this.$message({
            message: '请输入密码！',
            type: 'error',
            center: true
          });
          return;
        } else {
          let userinfor = { //将登录信息统一定义一个局部变量
            mobile: this.mobile,
            password: this.password,
          }

          var api = 'http://api.yopoo.cn/api/v1/login'
          Axios.post(api, userinfor).then((res) => {
            // alert('阻断') //阻断
						var nowDate = new Date();
						var newData = nowDate.getTime() //获取当前时间戳
						storage.set('logintime',newData)

            if (res.data.code == '200') { //判断后台状态码，状态只有200和202，后台自定义

              this.$message({
                message: '登录成功！',
                type: 'success',
                center: true

              });
              var nowDate = new Date();		//获取当前时间戳
              storage.set("logintime", nowDate.getTime())
              if (res.data.picture == null) { //判断是否有头像设置，没有则添加默认头像
                this.picture = 'https://yopoo.oss-cn-beijing.aliyuncs.com/motx.jpg'
                this.picture = storage.set('picture', this.picture)
              } else {
                this.picture = storage.set('picture', res.data.picture)
              }
              storage.set('username', res.data.username) //存储用户登陆的信息，信息由接口传回
              storage.set('token', res.data.token) //存储token信息，以便后面进行权限判断
              storage.set('iden', res.data.iden)
              storage.set('userdata', res.data.data) //存储用户登陆身份信息，以便后面进行页面权限判断
              storage.set('card', res.data.card)

              if (res.data.iden == '1') { //艺人iden＝1
                // alert('阻断')//阻断

                  setTimeout(() => {

                    this.$router.push({
                      path: '/per_admin/perinfor', //缺省页判断,有值则跳转详情页

                    })
                    location.reload()

                  }, 500);


              }
              if (res.data.iden == '2') { //剧组iden＝2
                // alert('asdf')//阻断测试
                if (res.data.data == '') { //缺省页判断
                  setTimeout(() => {
                    this.$router.push({
                      path: '/group_admin/missing',

                    })
                    location.reload()

                  }, 500);


                } else {


                  setTimeout(() => {
                    this.$router.push( //此代码无法跳转
                      {
                        path: '/group_admin/release',
                      }
                    ) //登录后跳转页面
                    location.reload()
                  }, 500);
                }
              }
              if (res.data.iden == '3') { //经纪人iden＝3

                  setTimeout(() => {
                    this.$router.push({
                      path: '/per_admin/perinfor',
                    })
                    location.reload()
                  }, 500);

              }
            } else {
              // this.$router.replace('/login');
            }
            if (res.data.code == '202') { //后台返回202自定义码来获取错误信息
              this.$message({
                message: res.data.msg,
                type: 'error',
                center: true
              });
            }
          }).catch((res) => {

          })
        }
      },
    },
    created() {
      this.$emit('public_footer', false);
    }
  }
</script>
<style lang="less" rel="stylesheet" scoped>
  .form-foo {
    margin-top: 20px;
    color: #555;
  }
  .container{
    display: flex;
    align-items: center;
    width: 1200px;
    margin: 0 auto;
    font-size: 32px;
    color: #fff;
    vertical-align: top;
    font-weight: bold;
    margin-top: 40px;
    .login-line{
      padding: 0 20px;
    }
    .login-logo{
      width: 200px;
      height: 46px;
      background: url("http://yopoo.oss-cn-beijing.aliyuncs.com/logo.png") no-repeat center center;
      background-size: 100% 100%;
      display: inline-block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue